export const NEWEST_FIRST_SORT = { column: 'updatedAt', direction: 'desc' } as const
